import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'webstore-listing-empty-state',
  templateUrl: './listing-empty-state.component.html',
  styleUrls: ['./listing-empty-state.component.scss'],
  imports: [CommonModule]
})
export class ListingEmptyStateComponent {


  readonly currentSection = input<string>('');
}

